import Hls from "hls.js";

import { PlayerStoreProperties } from "../../store/store";

export const setupHls = ({
  manifestUrl,
  setError
}: {
  manifestUrl: string;
  setError: PlayerStoreProperties["setError"];
}) => {
  const hls = new Hls();

  hls.on(Hls.Events.ERROR, (_, { details, fatal, type }) => {
    if (fatal) {
      setError({ details, type });
    }
  });

  hls.on(Hls.Events.MEDIA_ATTACHED, () => {
    hls.loadSource(manifestUrl);
  });

  return hls;
};
